<style scoped>
.printPage .page-title {
  font-size: 24px;
  font-weight: 600;
}
.page-title-txt {
  font-size: 14px;
  font-weight: 600;
  text-align: left;
}
table {
  border-color: #000;
  border-spacing: 0px;
  line-height: 30px;
  width: 100%;
  border-top: none;
  border-left: none;
  text-align: left;
}
table tr td,
.tdBg {
  /* border-bottom: none;
  border-right: none; */
  border-color: #bcbcbc;
  padding: 0 6px;
}
.tdBg {
  background: #f3f3f3;
}
.tdCenter {
  text-align: center;
  border-right: none;
}
.page-write {
  text-align: left;
  display: flex;
  width: 100%;
  height: 170px;
  border: 1px solid #000;
  /* padding: 90px 60px;
  box-sizing: border-box; */
  
}
.page-write div{
  flex: 1;
  padding:10px 100px  100px 10px;

}
.page-write div:first-child{
  border-right: 1px solid #000;
}
</style>
<template>
  <div class="printPage">
    <el-dialog
      title="打印预览"
      :visible.sync="showPrintDialog"
      width="1000px"
      :show-close="false"
      :close-on-click-modal="false"
    >
      <!-- 考核 -->
      <div id="printBill" style="padding:0 30px 0 30px ; color:black ; font-family: 宋体">
        <h2  style="font-size: 24px!important;font-weight: 700;">推广计划确认单<div style="font-size:14px;font-weight: normal;">(执行日期：{{printData.accountMonthStartDate}}至{{printData.accountMonthEndDate}})</div></h2>
        <p class="page-title-txt">致{{printData.tenantName}}：</p>
        <p class="page-title-txt mb15">
          根据贵公司与我公司所签订的相关服务协议，请贵公司确认以下推广计划，谢谢。
        </p>
        <div style="display: flex;justify-content: space-between;flex-wrap: nowrap;">
            <p style="width: 48%;text-align: left;">委托方：{{printData.tenantName}}</p>
            <p style="width: 48%;text-align: right;">服务方：{{printData.serviceTenantName}}</p>
          </div>
          <div style="display: flex;justify-content: flex-start;flex-wrap: nowrap;">
            <div style="width: 72px;">任务标题：</div>
            <div style="width: 80%;">
              <div style="margin-bottom:10px;text-align: left;" v-for="item in printData.taskInfoList">
                {{ item.name ||'-' }}
              </div>
            </div>
          </div>
          
        
        <table border class="mb30" style="width:100%">
          <tr class="t-center">
            <th class="tdBg" width="55">序号</th>
            <th class="tdBg" width="100">任务类型</th>
            <th class="tdBg" width="100">数量</th>
            <th class="tdBg" width="130">价格</th>
            <th class="tdBg">任务描述</th>
          </tr>
          <tr v-for="(item, index) in planData" :key="index">
            <td class="t-center">{{ index + 1 }}</td>
            <td>{{ item.taskContentName }}</td>
            <td class="t-right" style="white-space:nowrap">
              <template >
                <div v-if="item.taskTotalType!='固定量人均'&&item.taskTotalType!='不限量'"  style="display: flex; align-items: center;text-align: right;justify-content: flex-end">
                  <div>{{ item.taskTotal }}</div>
                  <span style="margin-left: 4px">{{ item.taskTotalUnit }}</span>
                </div>
                <div v-if="item.taskTotalType=='固定量人均'"  style="display: flex; align-items: center;text-align: right;justify-content: flex-end">
                  <div>{{ item.taskAvg }}</div>
                  <span style="margin-left: 4px">{{ item.taskTotalUnit }}</span>
                </div>
                <div v-if="item.taskTotalType=='不限量'" style="display: flex; align-items: center;text-align: right;justify-content: flex-end">
                  <div>不限量</div>
                </div>
              </template>
            </td>
            <td class="t-right">
              <template >{{ item.tenantTaskPrice }} {{ item.tenantTaskPriceUnit }}</template>
            </td>
            <td >
              <template >{{ getTenantTaskNote(item) }}</template>
            </td>
            
          </tr>
          
        </table>
        <!-- <p class="page-title-txt">如有任何疑问，请与我司药企服务事业部{{printData.contacts}}进行联系，谢谢！</p> -->
        <div class="page-write">
          <div>申请单位（盖章）：</div>
          <div>审核单位（盖章）：</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closePrint" style="color: #4fa1a4">取 消</el-button>
        <el-button size="small" type="primary" @click="billPrintClick" style="color: #fff">打 印</el-button>
        <!-- <el-button size="small" type="primary" @click="exportDocx" style="color: #fff">导出</el-button> -->
      </span>
    </el-dialog>
  </div>
</template>
<script>
// import print from 'print-js';
import printJS from '@/assets/js/print.min.js'
import { saveAs } from 'file-saver';
import htmlDocx from 'html-docx-js/dist/html-docx';
export default {
  name: 'printPage',
  props: {
    showPrintDialog: {
      type: Boolean,
      default: false,
    },
    printType: {
      //内容类型
      type: Number,
      default: 1,
    },
    printData: {
      //内容
      type: Object,
      default: {},
    },
    planData: {
      //内容
      type: Array,
      default: [],
    },
    currentTenantName: {
      //内容
      type: String,
      default: null,
    },
  },
  data() {
    return {
      sendCopy: '',
      staffName:null
    };
  },
  created() {
    let userInfo = JSON.parse(localStorage.userInfo);
    this.staffName = userInfo.staffName;
    
  },
  methods: {
    // 任务描述
    getTenantTaskNote(detail) {
      if (detail.taskTotalType == '固定量人均') {
        var total = detail.taskTotal;
        return detail.tenantTaskNote.replace('#总任务量#', total);
      } else if (detail.taskTotalType == '系统计算') {
        var total = detail.taskTotal;
        return detail.tenantTaskNote.replace('#总任务量#', total);
      }
    },
    fmoney(num) {
      if (!num) {
        return '0.00';
      }
      num = num.toString().replace(/\$|\,/g, '');
      if (isNaN(num)) num = '0';
      var sign = num == (num = Math.abs(num));
      num = Math.floor(num * 100 + 0.50000000001);
      var cents = num % 100;
      num = Math.floor(num / 100).toString();
      if (cents < 10) cents = '0' + cents;
      for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++)
        num = num.substring(0, num.length - (4 * i + 3)) + ',' + num.substring(num.length - (4 * i + 3));
      return (sign ? '' : '-') + num + '.' + cents;
    },
    getAmount(res) {
      if (!res) return '-';
      var list = [];
      var res = JSON.parse(res);
      res.forEach((item, index) => {
        list.push(`${item.costTypeName}${this.fmoney(item.costAmount)}元`);
      });
      return list.join('、');
    },
    getGoodsName(res) {
      if (!res) return;
      var list = [];
      var res = JSON.parse(res);
      res.forEach((item, index) => {
        list.push(`${item.name}<span style="color:#9F9F9F;font-size:14px !important;">(${item.goodsSpec})</span>`);
      });
      return list.join('、');
    },
    getDocorName(res) {
      if (!res) return;
      if (res.indexOf('name') > -1) {
        var list = [];
        var res = JSON.parse(res);
        if (res.length >= 2) {
          res.forEach((item, index) => {
            list.push(item.name);
          });
          return list.join('、');
        } else {
          return res[0].name;
        }
      } else {
        return res;
      }
    },
    // 导出 word 文档
    exportDocx() {
      let arr = document.querySelector('#printBill'); //获取dom
      let html = arr.innerHTML; //获取html的内容
      let htmlStr = `
      <!DOCTYPE html>
      <html lang="en">
        <body>
          ${html}
        </body>
      </html>`; //把获取到的html放入到原生的html中
      saveAs(htmlDocx.asBlob(htmlStr, { orientation: 'landscape' }), '推广计划确认单.doc'); // 导出为word
    },
    //关闭打印
    closePrint() {
      this.$emit('closePrint');
    },
    billPrintClick() {
      let str = '';
      const style = '@page {margin:0 10mm};'; //打印时去掉眉页眉尾
      printJS({
        printable: 'printBill', // 标签元素id
        type: 'html',
        header: '',
        documentTitle: str,
        targetStyles: ['*'],
        scanStyles: true,
        // style
      });
      //各个配置项
      //printable:要打印的id。
      //type:可以是 html 、pdf、 json 等。
      //properties:是打印json时所需要的数据属性。
      //gridHeaderStyle和gridStyle都是打印json时可选的样式。
      //repeatTableHeader:在打印JSON数据时使用。设置为时false，数据表标题将仅在第一页显示。
      //scanStyles:设置为false时，库将不处理应用于正在打印的html的样式。使用css参数时很有用，此时自己设置的原来想要打印的样式就会失效，在打印预览时可以看到效果
      //targetStyles: [’*’],这样设置继承了页面要打印元素原有的css属性。
      //style:传入自定义样式的字符串，使用在要打印的html页面 也就是纸上的样子。
      //ignoreElements：传入要打印的div中的子元素id，使其不打印。非常好用
      this.closePrint();
    },
    // 处理数据
    caCodeToDesc(listStr) {
      if (listStr != '') {
        listStr = listStr
          .replace(/\"/g, '')
          .replace(/[\\]/g, '')
          .replace(/\[/g, '')
          .replace(/\]/g, '')
          .replace(/\,/g, '；');
        console.log(listStr);
        return listStr;
      }
    },
    changeEnter(content) {
      if (content == '' || content == null) {
        return '无';
      } else {
        content = content.replace(/\n/g, '</br>');
        return content;
      }
    },
  },
};
</script>
